var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_33632)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_616_33632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8701 14.6673L24.4631 40.334H37.1021C39.6321 40.334 41.4141 42.809 40.6147 45.2107L34.5427 63.423L61.3021 36.6673H51.8787C51.2474 36.6672 50.6266 36.5057 50.0753 36.1981C49.524 35.8906 49.0605 35.4472 48.7287 34.9101C48.397 34.373 48.2081 33.76 48.1799 33.1293C48.1517 32.4986 48.2852 31.8712 48.5677 31.3067L56.8874 14.6673H35.8701ZM30.1281 9.53398C30.7221 8.19565 32.0457 7.33398 33.5124 7.33398H62.7614C65.5114 7.33398 67.3044 10.2307 66.0724 12.6947L57.7527 29.334H70.0654C73.3654 29.334 75.0154 33.3233 72.6834 35.6553L28.8557 79.483C26.0911 82.2477 21.4857 79.4023 22.7251 75.6953L32.0677 47.6673H18.8751C18.2581 47.6673 17.651 47.5131 17.1087 47.2189C16.5665 46.9246 16.1064 46.4995 15.7702 45.9823C15.434 45.465 15.2323 44.8719 15.1835 44.2569C15.1347 43.6419 15.2403 43.0245 15.4907 42.4607L30.1281 9.53398Z",
    fill: "#30D689"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_616_33632",
    x: 2.46001,
    y: -5.37788,
    width: 84.0272,
    height: 98.6796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.35593
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.839216 0 0 0 0 0.537255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_616_33632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_616_33632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_33632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.c8b4f3993d71c9c90375fb013be0ce63.svg";
export { ForwardRef as ReactComponent };